import client from './client';

export const setLang = ({ language }) =>
  client.post(
    '/v1/setLang/',
    { language },
    { headers: { 'X-API-KEY': client.apiKey_en } },
  );

export const appInfo = () =>
  client.get('/v1/app-info/', { headers: { 'X-API-KEY': client.apiKey_en } });

export const getIpInfo = async () => {
  try {
    const response = await fetch('https://api.country.is/');
    const data = await response.json();

    if (data.country) {
      return {
        data: {
          country_code: data.country,
        },
      };
    }
    return { data: null };
  } catch (error) {
    console.warn('Failed to get IP info:', error.message);
    return { data: null };
  }
};
